/**
 * Analytics.
 *
 * @version 3.4.6
 * @since   2.4.5
 * @author  WPFactory
 */

// Orders.
import orders from './modules/orders';
orders.init();

// Revenue.
import revenue from './modules/revenue';
revenue.init();

// Stock.
import stock from './modules/stock';
stock.init();

// Products.
import products from './modules/products';
products.init();

// Variations.
import variations from './modules/variations';
variations.init();

// Categories.
import categories from './modules/categories';
categories.init();

// Customers.
import customers from './modules/customers';
customers.init();